// removed by extract-text-webpack-plugin
module.exports = {"aside":"src-node_modules-kts-platform-frame-display-part-Aside-index__aside--26Ym9"};


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-platform-frame/display/part/Aside/index.scss
// module id = 3784
// module chunks = 0